import { RefObject } from "react";
import { useTranslation } from "react-i18next";
import { ProductType } from "../../shared/enums/ProductType";
import { ListObject } from "../../shared/types/ListObject";
import { ProductItem } from "../../shared/types/ProductItem";
import ProductSeperator from "../Products/ProductSeperator";
import Tools from "./Tools";

interface ToolsProductProps {
  onListObjectChange(productItem: ListObject): void;
  onProductTypeChange(productType: ProductType): void;
  refToolsItems: RefObject<HTMLDivElement>;
  refToolsProduct: RefObject<HTMLDivElement>;
  refToolsProductItemsList: RefObject<HTMLDivElement>;
  selectedToolsProductItems: ProductItem[];
  selectedToolsProductTypes: ProductType[];
}

const ToolsProduct = ({
  onListObjectChange,
  onProductTypeChange,
  refToolsItems,
  refToolsProduct,
  refToolsProductItemsList,
  selectedToolsProductItems,
  selectedToolsProductTypes,
}: ToolsProductProps) => {
  const { t } = useTranslation(["tools"]);

  return (
    <div ref={refToolsProduct}>
      <ProductSeperator />
      <h3>
        {t("ourtools")}
        <sup>*</sup>
      </h3>
      <p className="font">{t("disclamertools")}</p>
      <Tools
        onListObjectChange={onListObjectChange}
        onProductTypeChange={onProductTypeChange}
        refToolsItems={refToolsItems}
        refToolsProductItemsList={refToolsProductItemsList}
        selectedToolsProductItems={selectedToolsProductItems}
        selectedToolsProductTypes={selectedToolsProductTypes}
      />
    </div>
  );
};

export default ToolsProduct;
